import { AcquirerPhysicalDtoToEntity } from "src/app/features/Acquirer/services/mappers/AcquirerPhysicalDtoToEntity";
import type { AcquirerDto } from "src/app/features/Acquirer/types/AcquirerDto";
import type { AcquirerEntity } from "src/app/features/Acquirer/types/AcquirerEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const AcquirerTableDtoMapper = (input: Readonly<ResourcePageDto<AcquirerDto>>): ResourcePageEntity<AcquirerEntity> => {
    return {
        list: input.list ? input.list.map(AcquirerPhysicalDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
